// extracted by mini-css-extract-plugin
export default {"tilesContainer":"TilesBoard_tilesContainer__AUh4w"};